// links
export const CONTACTS_LINK =
  "https://res.cloudinary.com/koruja/image/upload/v1581307515/koruja/assets/CONTACTS.jpg";
export const GB_FLAG_LINK =
  "https://res.cloudinary.com/koruja/image/upload/v1581557031/koruja/assets/gb.png";
export const RU_FLAG_LINK =
  "https://res.cloudinary.com/koruja/image/upload/v1581644536/koruja/assets/RU_p32pbt.png";
export const PUBLIC_ID_INSTAGRAM_ICON = "koruja/assets/instagram0.2_v2ozw6";
// common
export const LOGO_NAME = "KRJ";
export const CLOUD_NAME = "koruja";
// about
export const ABOUT_PUBLIC_ID = "koruja/assets/about_exbp76.jpg";
// new Items
export const ILLUMA_PUBLIC_ID = "products/meso/iLLUMA 2.jpg";

// products
export const PRODUCTS = "products";
export const PRODUCTS_TOXINS = "toxins";
export const PRODUCTS_MESO = "meso";
export const PRODUCTS_FILLERS = "fillers";
export const PRODUCTS_TABS = {
  cosmetics: {
    toxins: [
      "NABOTA_100U",
      "INNOTOX_50U",
      "HUTOX_100U",
      "MEDITOXIN_100U",
      "BOTULAX_200U",
      "NEURONOX_100U",
      "BOTULAX_100",
    ],
    fillers: [
      "ELOHA",
      "HYAFILIA____",
      "CELOSOME____",
      "REPLENGEN_",
      "NEURAMIS___",
      "DERMALAX___",
      "MELINE_",
    ],
    meso: [
      // "ILLUMA",
      "iLLUMA 1",
      "iLLUMA 2",
      "iLLUMA Crystal 1",
      "iLLUMA Crystal 2",
      "iLLUMA Crystal 3",
      // "iLLUMA 3",
      // "iLLUMA 4",
      "HYARON",
      "LUMI_EYE__",
      "HIDR_INJ_",
      "CELOSOME_AQUA_",
      "DOTOTHY",
      "REGENOVUE_AQUASHINE",
    ],
  },
  lifting: {
    desc: [
      "Thread_leaflet.pdf-4_sok2w",
      "Thread_leaflet.pdf-4_t9jk2d",
      "liftkin_phi5",
      "bomb_alp3n",
      "gog_ll40l",
      "nose_n9ks6",
      "mesh_kizny",
      "twin_gobvx",
      "arrow_wb8og",
    ],
  },
};

export const PRODUCTS_COSMETICS_STEPS = [
  {
    name: "choice",
    icon: "info",
    color: "blue",
    image: "odm_oem_4_ljkk92.jpg",
  },
  {
    name: "test",
    icon: "industry",
    color: "yellow",
    image: "experiment_dvmj5k1",
  },
  {
    name: "prod",
    icon: "truck",
    color: "green",
    image: "mass_prod_3_fgmzwt",
  },
];

// contacts
// export const USER_ID = "user_1D0BOMjDfxEea3jbnCdmp";
// export const TEMPLATE_ID = "template_Jpj3zWxG";
//
export const USER_ID = "user_PaYNGMPfAiBf1CSGaI3Vq";
export const TEMPLATE_ID = "template_OqhctrzW";
export const NAME_LENGTH = 2;
export const MINIMUM_MESSAGE_LENGTH = 15;
export const MAX_MESSAGE_LENGTH = 250;
export const SERVICE_ID = "gmail";

// footer
export const EMAIL_NAME = "krj.shop7@gmail.com";
export const NETWORKS_NUMBER = "+82-10-387-75702";
export const ADDITIONAL_NUMBER = "+82-55-266-8400";

// languages

export const LANGUAGES = {
  ru: "ru-RU",
  en: "en-US",
};

export const KEY_LANGUAGE_MATCHER = {
  "en-US": "EN",
  "ru-RU": "RU",
};
